(function () {
  function uid() {
    return 'pv_' + Math.random().toString(36).slice(2) + '_' + Date.now().toString(36);
  }

  function getStorageKey(token) {
    return 'poster_preview_' + token;
  }

  function safeSetLocalStorage(key, val) {
    try {
      localStorage.setItem(key, val);
      return true;
    } catch (e) {
      return false;
    }
  }

  function findSectionIdFromRoot(root) {
    if (!root || !root.id) return null;
    var prefix = 'MainProduct-';
    if (root.id.indexOf(prefix) !== 0) return null;
    return root.id.slice(prefix.length);
  }

  function isTransparent(bg) {
    if (!bg) return true;
    return bg === 'transparent' || bg === 'rgba(0, 0, 0, 0)';
  }

  function waitForImages(node, timeoutMs) {
    timeoutMs = timeoutMs || 2000;
    if (!node) return Promise.resolve();

    var imgs = Array.prototype.slice.call(node.querySelectorAll('img'));
    if (!imgs.length) return Promise.resolve();

    return new Promise(function (resolve) {
      var done = false;

      var t = setTimeout(function () {
        if (done) return;
        done = true;
        resolve();
      }, timeoutMs);

      var pending = 0;

      function finishOne() {
        pending--;
        if (pending <= 0 && !done) {
          done = true;
          clearTimeout(t);
          resolve();
        }
      }

      imgs.forEach(function (img) {
        try { img.crossOrigin = 'anonymous'; } catch (e) {}
        if (img.complete && img.naturalWidth > 0) return;

        pending++;
        img.addEventListener('load', finishOne, { once: true });
        img.addEventListener('error', finishOne, { once: true });
      });

      if (pending === 0 && !done) {
        done = true;
        clearTimeout(t);
        resolve();
      }
    });
  }

  // Rasterize <img src="...svg"> -> PNG dataURL (SVG často selže v html2canvas)
  // ⚠️ Upraveno: skipujeme IMG s CSS filtrem "invert" (znamení konstelace se řeší specialně)
  function rasterizeSvgImgs(node, timeoutMs) {
    timeoutMs = timeoutMs || 2500;
    if (!node) return Promise.resolve({ restore: function () {} });

    var imgs = Array.prototype.slice.call(node.querySelectorAll('img'));

    var svgImgs = imgs.filter(function (img) {
      var src = (img.getAttribute('src') || '').toLowerCase();
      if (src.indexOf('.svg') === -1) return false;

      // skip - pokud je na elementu invert filter, bude řešeno specialně (upečení do PNG)
      try {
        var cs = window.getComputedStyle(img);
        var f = (cs && cs.filter) ? cs.filter : '';
        if (f && f.indexOf('invert') !== -1) return false;
      } catch (e) {}

      return true;
    });

    if (!svgImgs.length) return Promise.resolve({ restore: function () {} });

    var originals = [];

    function toAbsUrl(url) {
      var abs = url || '';
      if (abs.indexOf('//') === 0) abs = window.location.protocol + abs;
      return abs;
    }

    function fetchText(url) {
      var abs = toAbsUrl(url);
      return fetch(abs, { mode: 'cors', credentials: 'same-origin' })
        .then(function (r) { return r.text(); });
    }

    function svgTextToPngDataUrl(svgText, w, h) {
      return new Promise(function (resolve) {
        try {
          var blob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
          var blobUrl = URL.createObjectURL(blob);

          var img = new Image();
          img.crossOrigin = 'anonymous';

          var done = false;
          var t = setTimeout(function () {
            if (done) return;
            done = true;
            try { URL.revokeObjectURL(blobUrl); } catch (e) {}
            resolve(null);
          }, timeoutMs);

          img.onload = function () {
            if (done) return;
            done = true;
            clearTimeout(t);

            try {
              var cw = w || img.naturalWidth || 1200;
              var ch = h || img.naturalHeight || 1200;

              var c = document.createElement('canvas');
              c.width = cw;
              c.height = ch;

              var ctx = c.getContext('2d');
              ctx.imageSmoothingEnabled = true;
              ctx.imageSmoothingQuality = 'high';

              var iw = img.naturalWidth || cw;
              var ih = img.naturalHeight || ch;

              var r = Math.min(cw / iw, ch / ih);
              var dw = Math.round(iw * r);
              var dh = Math.round(ih * r);
              var dx = Math.round((cw - dw) / 2);
              var dy = Math.round((ch - dh) / 2);

              ctx.clearRect(0, 0, cw, ch);
              ctx.drawImage(img, dx, dy, dw, dh);

              var png = c.toDataURL('image/png');
              try { URL.revokeObjectURL(blobUrl); } catch (e) {}
              resolve(png);
            } catch (e) {
              try { URL.revokeObjectURL(blobUrl); } catch (e2) {}
              resolve(null);
            }
          };

          img.onerror = function () {
            if (done) return;
            done = true;
            clearTimeout(t);
            try { URL.revokeObjectURL(blobUrl); } catch (e) {}
            resolve(null);
          };

          img.src = blobUrl;
        } catch (e) {
          resolve(null);
        }
      });
    }

    return Promise.all(svgImgs.map(function (imgEl) {
      try {
        var src = imgEl.getAttribute('src') || '';
        originals.push({ el: imgEl, src: src });

        var rect = imgEl.getBoundingClientRect();
        var scale = 3;

        var w = Math.max(1, Math.round(rect.width * scale));
        var h = Math.max(1, Math.round(rect.height * scale));

        var maxSide = 2200;
        if (w > maxSide || h > maxSide) {
          var k = Math.min(maxSide / w, maxSide / h);
          w = Math.max(1, Math.round(w * k));
          h = Math.max(1, Math.round(h * k));
        }

        return fetchText(src)
          .then(function (svgText) { return svgTextToPngDataUrl(svgText, w, h); })
          .then(function (pngDataUrl) {
            if (pngDataUrl) imgEl.setAttribute('src', pngDataUrl);
          })
          .catch(function () {});
      } catch (e) {
        return Promise.resolve();
      }
    })).then(function () {
      return {
        restore: function () {
          for (var i = 0; i < originals.length; i++) {
            try { originals[i].el.setAttribute('src', originals[i].src); } catch (e) {}
          }
        }
      };
    });
  }

  // ✅ KLASICKÝ ZNAMENÍ: vyrenderuj inline SVG hvězd do PNG a dej ho jako background
  function svgNodeToPngDataUrl(svgNode, w, h, timeoutMs) {
    timeoutMs = timeoutMs || 2500;
    if (!svgNode) return Promise.resolve(null);

    function ensureSvgNamespaces(svgEl) {
      try {
        if (!svgEl.getAttribute('xmlns')) svgEl.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        if (!svgEl.getAttribute('xmlns:xlink')) svgEl.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
      } catch (e) {}
    }

    function fixMaskToAttribute(svgEl) {
      // v SVG je maska přes CSS (.st1 { mask: url(#mask) })
      // při rasterizaci se to často ztratí -> dáme atribut mask přímo
      try {
        var masked = svgEl.querySelectorAll('.st1');
        for (var i = 0; i < masked.length; i++) {
          try { masked[i].setAttribute('mask', 'url(#mask)'); } catch (e) {}
        }
      } catch (e) {}
    }

    function forceStarsFillWhite(svgEl) {
      // hvězdy v souboru nemají fill, někdy je barví CSS na stránce
      // při převodu do PNG to CSS nemusí existovat -> vynutíme bílou
      try {
        var els = svgEl.querySelectorAll('circle, path');
        for (var i = 0; i < els.length; i++) {
          try { els[i].setAttribute('fill', '#fff'); } catch (e) {}
        }
      } catch (e) {}
    }

    return new Promise(function (resolve) {
      try {
        var clone = svgNode.cloneNode(true);
        ensureSvgNamespaces(clone);
        fixMaskToAttribute(clone);
        forceStarsFillWhite(clone);

        var svgText = new XMLSerializer().serializeToString(clone);

        var blob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
        var blobUrl = URL.createObjectURL(blob);

        var img = new Image();
        img.crossOrigin = 'anonymous';

        var done = false;
        var t = setTimeout(function () {
          if (done) return;
          done = true;
          try { URL.revokeObjectURL(blobUrl); } catch (e) {}
          resolve(null);
        }, timeoutMs);

        img.onload = function () {
          if (done) return;
          done = true;
          clearTimeout(t);

          try {
            var cw = w || img.naturalWidth || 1200;
            var ch = h || img.naturalHeight || 1200;

            var c = document.createElement('canvas');
            c.width = cw;
            c.height = ch;

            var ctx = c.getContext('2d');
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
            ctx.clearRect(0, 0, cw, ch);

            // contain
            var iw = img.naturalWidth || cw;
            var ih = img.naturalHeight || ch;
            var r = Math.min(cw / iw, ch / ih);
            var dw = Math.round(iw * r);
            var dh = Math.round(ih * r);
            var dx = Math.round((cw - dw) / 2);
            var dy = Math.round((ch - dh) / 2);

            ctx.drawImage(img, dx, dy, dw, dh);

            var png = c.toDataURL('image/png');
            try { URL.revokeObjectURL(blobUrl); } catch (e) {}
            resolve(png);
          } catch (e) {
            try { URL.revokeObjectURL(blobUrl); } catch (e2) {}
            resolve(null);
          }
        };

        img.onerror = function () {
          if (done) return;
          done = true;
          clearTimeout(t);
          try { URL.revokeObjectURL(blobUrl); } catch (e) {}
          resolve(null);
        };

        img.src = blobUrl;
      } catch (e) {
        resolve(null);
      }
    });
  }

  // ===============================
  // ZNAMENI capture helpers
  // ===============================
  function fixZnameniCircleBoxForCapture(previewRoot) {
    if (!previewRoot) return { restore: function () {} };

    var isZnameni = previewRoot.classList.contains('poster-preview--znameni');
    var isKlasicky = previewRoot.classList.contains('poster-preview--layout-klasicky');
    if (!isZnameni || !isKlasicky) return { restore: function () {} };

    var starsWrap = previewRoot.querySelector('.poster-preview__stars');
    var constWrap = previewRoot.querySelector('.poster-preview__constellation');
    if (!starsWrap || !constWrap) return { restore: function () {} };

    var prev = {
      starsH: starsWrap.style.height,
      constH: constWrap.style.height
    };

    var w = starsWrap.getBoundingClientRect().width;
    if (w && isFinite(w)) {
      var px = Math.max(1, Math.round(w)) + 'px';
      starsWrap.style.height = px;
      constWrap.style.height = px;
    }

    return {
      restore: function () {
        try {
          starsWrap.style.height = prev.starsH || '';
          constWrap.style.height = prev.constH || '';
        } catch (e) {}
      }
    };
  }

  function invertImageData(imgData) {
    var d = imgData.data;
    for (var i = 0; i < d.length; i += 4) {
      d[i] = 255 - d[i];
      d[i + 1] = 255 - d[i + 1];
      d[i + 2] = 255 - d[i + 2];
    }
    return imgData;
  }

  function svgUrlToPngDataUrl(svgUrl, w, h, invertFlag, timeoutMs) {
    timeoutMs = timeoutMs || 2500;

    function toAbsUrl(url) {
      var abs = url || '';
      if (abs.indexOf('//') === 0) abs = window.location.protocol + abs;
      return abs;
    }

    function fetchText(url) {
      return fetch(toAbsUrl(url), { mode: 'cors', credentials: 'same-origin' })
        .then(function (r) { return r.text(); });
    }

    return fetchText(svgUrl).then(function (svgText) {
      return new Promise(function (resolve) {
        try {
          var blob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
          var blobUrl = URL.createObjectURL(blob);

          var img = new Image();
          img.crossOrigin = 'anonymous';

          var done = false;
          var t = setTimeout(function () {
            if (done) return;
            done = true;
            try { URL.revokeObjectURL(blobUrl); } catch (e) {}
            resolve(null);
          }, timeoutMs);

          img.onload = function () {
            if (done) return;
            done = true;
            clearTimeout(t);

            try {
              var cw = Math.max(1, Math.round(w || img.naturalWidth || 1200));
              var ch = Math.max(1, Math.round(h || img.naturalHeight || 1200));

              var c = document.createElement('canvas');
              c.width = cw;
              c.height = ch;

              var ctx = c.getContext('2d');
              ctx.imageSmoothingEnabled = true;
              ctx.imageSmoothingQuality = 'high';

              var iw = img.naturalWidth || cw;
              var ih = img.naturalHeight || ch;
              var r = Math.min(cw / iw, ch / ih);
              var dw = Math.round(iw * r);
              var dh = Math.round(ih * r);
              var dx = Math.round((cw - dw) / 2);
              var dy = Math.round((ch - dh) / 2);

              ctx.clearRect(0, 0, cw, ch);
              ctx.drawImage(img, dx, dy, dw, dh);

              if (invertFlag) {
                var id = ctx.getImageData(0, 0, cw, ch);
                ctx.putImageData(invertImageData(id), 0, 0);
              }

              var png = c.toDataURL('image/png');
              try { URL.revokeObjectURL(blobUrl); } catch (e) {}
              resolve(png);
            } catch (e) {
              try { URL.revokeObjectURL(blobUrl); } catch (e2) {}
              resolve(null);
            }
          };

          img.onerror = function () {
            if (done) return;
            done = true;
            clearTimeout(t);
            try { URL.revokeObjectURL(blobUrl); } catch (e) {}
            resolve(null);
          };

          img.src = blobUrl;
        } catch (e) {
          resolve(null);
        }
      });
    }).catch(function () {
      return null;
    });
  }

  // Rasterizace konstelace (IMG se SVG) -> PNG dataURL + upečení invert filtru
  function rasterizeConstellationImgForCapture(previewRoot) {
    if (!previewRoot) return Promise.resolve({ restore: function () {} });

    var isZnameni = previewRoot.classList.contains('poster-preview--znameni');
    if (!isZnameni) return Promise.resolve({ restore: function () {} });

    var imgEl = previewRoot.querySelector('.poster-preview__constellation img');
    if (!imgEl) return Promise.resolve({ restore: function () {} });

    var src = imgEl.getAttribute('src') || '';
    if (src.toLowerCase().indexOf('.svg') === -1) {
      return Promise.resolve({ restore: function () {} });
    }

    var prevSrc = src;
    var rect = imgEl.getBoundingClientRect();
    var scale = 3;

    var w = Math.max(1, Math.round(rect.width * scale));
    var h = Math.max(1, Math.round(rect.height * scale));

    var maxSide = 2000;
    if (w > maxSide || h > maxSide) {
      var k = Math.min(maxSide / w, maxSide / h);
      w = Math.max(1, Math.round(w * k));
      h = Math.max(1, Math.round(h * k));
    }

    var cs = window.getComputedStyle(imgEl);
    var filter = (cs && cs.filter) ? cs.filter : '';
    var invertFlag = (filter && filter.indexOf('invert') !== -1);

    return svgUrlToPngDataUrl(prevSrc, w, h, invertFlag, 3000).then(function (pngDataUrl) {
      if (!pngDataUrl) return { restore: function () {} };

      var prevFilter = imgEl.style.filter;
      imgEl.setAttribute('src', pngDataUrl);
      imgEl.style.filter = 'none';

      return {
        restore: function () {
          try {
            imgEl.setAttribute('src', prevSrc);
            imgEl.style.filter = prevFilter || '';
          } catch (e) {}
        }
      };
    });
  }

  // Rasterizace hvězd (inline SVG) -> background PNG pro layout-klasicky
  function rasterizeClassicStarsToBackground(previewRoot) {
    if (!previewRoot) return Promise.resolve({ restore: function () {} });

    var isZnameni = previewRoot.classList.contains('poster-preview--znameni');
    var isKlasicky = previewRoot.classList.contains('poster-preview--layout-klasicky');
    if (!isZnameni || !isKlasicky) return Promise.resolve({ restore: function () {} });

    var starsBox = previewRoot.querySelector('.poster-preview__stars');
    if (!starsBox) return Promise.resolve({ restore: function () {} });

    var svg = starsBox.querySelector('svg');
    if (!svg) return Promise.resolve({ restore: function () {} });

    var prev = {
      svgDisplay: svg.style.display,
      bgImage: starsBox.style.backgroundImage,
      bgRepeat: starsBox.style.backgroundRepeat,
      bgPos: starsBox.style.backgroundPosition,
      bgSize: starsBox.style.backgroundSize,
      bgColor: starsBox.style.backgroundColor
    };

    var rect = starsBox.getBoundingClientRect();
    var w = Math.max(240, Math.round(rect.width * 2));
    var h = Math.max(240, Math.round(rect.height * 2));

    // přenést barvu kruhu (CSS var) do inline bgColor, ať to v canvasu sedí
    try {
      var cs = window.getComputedStyle(starsBox);
      var circleColor = cs.getPropertyValue('--stars-circle-color').trim();
      if (circleColor) starsBox.style.backgroundColor = circleColor;
    } catch (e) {}

    return svgNodeToPngDataUrl(svg, w, h, 3000).then(function (png) {
      if (!png) return { restore: function () {} };

      try { svg.style.display = 'none'; } catch (e) {}

      starsBox.style.backgroundImage = 'url("' + png + '")';
      starsBox.style.backgroundRepeat = 'no-repeat';
      starsBox.style.backgroundPosition = 'center center';
      starsBox.style.backgroundSize = 'cover';

      return {
        restore: function () {
          try { svg.style.display = prev.svgDisplay || ''; } catch (e) {}
          try { starsBox.style.backgroundImage = prev.bgImage || ''; } catch (e) {}
          try { starsBox.style.backgroundRepeat = prev.bgRepeat || ''; } catch (e) {}
          try { starsBox.style.backgroundPosition = prev.bgPos || ''; } catch (e) {}
          try { starsBox.style.backgroundSize = prev.bgSize || ''; } catch (e) {}
          try { starsBox.style.backgroundColor = prev.bgColor || ''; } catch (e) {}
        }
      };
    });
  }

  // High-level: připraví znamení pro capture (size fix + konstelace + hvězdy background)
  function prepareZnameniForCapture(previewRoot) {
    var sizeFix = fixZnameniCircleBoxForCapture(previewRoot);

    return Promise.all([
      rasterizeConstellationImgForCapture(previewRoot),
      rasterizeClassicStarsToBackground(previewRoot)
    ]).then(function (arr) {
      var c1 = arr && arr[0] ? arr[0] : null;
      var c2 = arr && arr[1] ? arr[1] : null;

      return {
        restore: function () {
          try { if (c1 && c1.restore) c1.restore(); } catch (e) {}
          try { if (c2 && c2.restore) c2.restore(); } catch (e) {}
          try { if (sizeFix && sizeFix.restore) sizeFix.restore(); } catch (e) {}
        }
      };
    });
  }

  function capturePreview(sectionRoot, sectionId) {
    if (!sectionRoot || !sectionId) return;

    var tokenInput = sectionRoot.querySelector('#PreviewToken-' + sectionId);
    if (!tokenInput) return;

    var token = tokenInput.value || uid();
    tokenInput.value = token;

    var previewRoot =
      sectionRoot.querySelector('.poster-preview[data-poster-section="' + sectionId + '"]') ||
      sectionRoot.querySelector('.poster-preview');
    if (!previewRoot) return;

    var frameNode = previewRoot.querySelector('.poster-preview__frame') || previewRoot;
    var innerNode = previewRoot.querySelector('.poster-preview__inner') || previewRoot;
    if (!frameNode || !innerNode || !window.html2canvas) return;

    var imageBg = previewRoot.querySelector('.poster-preview__image-bg');
    var shouldInvertLetter = previewRoot.classList.contains('poster-preview--invert-svg');

    // ✅ OUTLINE pro klasický layout (stejně jako v poster-preview-capture.js)
    var paperNode = previewRoot.querySelector('.poster-preview__paper');
    var isKlasicky = previewRoot.classList.contains('poster-preview--layout-klasicky');

    var prevInlineOutline = paperNode ? paperNode.style.outline : '';
    var prevInlineOutlineOffset = paperNode ? paperNode.style.outlineOffset : '';
    var didForceOutline = false;

    if (paperNode && isKlasicky) {
      var computedOutlineColor = window.getComputedStyle(paperNode).outlineColor || '#000';
      paperNode.style.outline = '3px solid ' + computedOutlineColor;
      paperNode.style.outlineOffset = '0px';
      didForceOutline = true;
    }

    // pokud by bg bylo transparent, dáme bílý fallback
    var prevInlineBg = innerNode.style.backgroundColor;
    var computedBg = window.getComputedStyle(innerNode).backgroundColor;
    var forcedBg = false;
    if (isTransparent(computedBg)) {
      innerNode.style.backgroundColor = '#ffffff';
      forcedBg = true;
    }

    // vynucení přepočtu layoutu
    void innerNode.offsetHeight;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        waitForImages(innerNode, 2500).then(function () {

          // ✅ 1) připravíme znamení před focením (stabilní pozice + rasterizace)
          prepareZnameniForCapture(previewRoot).then(function (znSwap) {

            // ✅ 2) obecná rasterizace SVG IMG (ale skip invertovaných)
            rasterizeSvgImgs(innerNode, 2500).then(function (svgR) {

              html2canvas(frameNode, {
                backgroundColor: null,
                scale: 1.5,
                useCORS: true,
                allowTaint: true,
                cacheBust: true,
                imageTimeout: 15000

                // onclone už nepotřebujeme pro klasický znamení (řešíme předem v živém DOMu)
              })
                .then(function (canvas) {
                  try { if (svgR && svgR.restore) svgR.restore(); } catch (e) {}
                  try { if (znSwap && znSwap.restore) znSwap.restore(); } catch (e) {}
                  if (forcedBg) innerNode.style.backgroundColor = prevInlineBg || '';

                  if (paperNode && didForceOutline) {
                    paperNode.style.outline = prevInlineOutline || '';
                    paperNode.style.outlineOffset = prevInlineOutlineOffset || '';
                  }

                  var targetW = 420;
                  var outCanvas = canvas;

                  if (canvas.width > targetW) {
                    var ratio = targetW / canvas.width;
                    var outW = Math.round(canvas.width * ratio);
                    var outH = Math.round(canvas.height * ratio);

                    outCanvas = document.createElement('canvas');
                    outCanvas.width = outW;
                    outCanvas.height = outH;

                    var octx = outCanvas.getContext('2d');
                    octx.imageSmoothingEnabled = true;
                    octx.imageSmoothingQuality = 'high';
                    octx.drawImage(canvas, 0, 0, outW, outH);
                  }

                  // ✅ dokreslení outline do výsledné miniatury (stejně jako v poster-preview-capture.js)
                  try {
                    if (paperNode && isKlasicky) {
                      var rootRect = frameNode.getBoundingClientRect();
                      var paperRect = paperNode.getBoundingClientRect();

                      var scaleX = outCanvas.width / rootRect.width;
                      var scaleY = outCanvas.height / rootRect.height;

                      var x = Math.round((paperRect.left - rootRect.left) * scaleX);
                      var y = Math.round((paperRect.top - rootRect.top) * scaleY);
                      var w = Math.round(paperRect.width * scaleX);
                      var h = Math.round(paperRect.height * scaleY);

                      var ctxO = outCanvas.getContext('2d');

                      var cssColor = getComputedStyle(paperNode).getPropertyValue('--poster-outline-color').trim();
                      if (!cssColor) cssColor = '#000';

                      var lineWidth = Math.max(1, Math.round(2 * ((scaleX + scaleY) / 2)));

                      ctxO.save();
                      ctxO.strokeStyle = cssColor;
                      ctxO.lineWidth = lineWidth;
                      ctxO.strokeRect(x, y, w, h);
                      ctxO.restore();
                    }
                  } catch (e) {}

                  if (shouldInvertLetter && imageBg) {
                    try {
                      var innerRect = frameNode.getBoundingClientRect();
                      var bgRect = imageBg.getBoundingClientRect();

                      var scaleX2 = outCanvas.width / innerRect.width;
                      var scaleY2 = outCanvas.height / innerRect.height;

                      var rx = Math.max(0, Math.round((bgRect.left - innerRect.left) * scaleX2));
                      var ry = Math.max(0, Math.round((bgRect.top - innerRect.top) * scaleY2));
                      var rw = Math.min(outCanvas.width - rx, Math.round(bgRect.width * scaleX2));
                      var rh = Math.min(outCanvas.height - ry, Math.round(bgRect.height * scaleY2));

                      var ctx = outCanvas.getContext('2d');
                      var imgData = ctx.getImageData(rx, ry, rw, rh);
                      var d = imgData.data;

                      var maxDark = 70;
                      var minAlpha = 10;

                      for (var i = 0; i < d.length; i += 4) {
                        var rr = d[i], gg = d[i + 1], bb = d[i + 2], aa = d[i + 3];
                        if (aa > minAlpha && rr < maxDark && gg < maxDark && bb < maxDark) {
                          d[i] = 255; d[i + 1] = 255; d[i + 2] = 255;
                        }
                      }

                      ctx.putImageData(imgData, rx, ry);
                    } catch (e) {}
                  }

                  var dataUrl = outCanvas.toDataURL('image/jpeg', 0.72);
                  var ok = safeSetLocalStorage(getStorageKey(token), dataUrl);

                  if (ok) {
                    window.dispatchEvent(new CustomEvent('posterPreview:stored', { detail: { token: token } }));
                  }
                })
                .catch(function () {
                  try { if (svgR && svgR.restore) svgR.restore(); } catch (e) {}
                  try { if (znSwap && znSwap.restore) znSwap.restore(); } catch (e) {}
                  if (forcedBg) innerNode.style.backgroundColor = prevInlineBg || '';

                  if (paperNode && didForceOutline) {
                    paperNode.style.outline = prevInlineOutline || '';
                    paperNode.style.outlineOffset = prevInlineOutlineOffset || '';
                  }
                });

            });

          });

        });
      });
    });
  }

  function bindToSection(sectionRoot) {
    var sectionId = findSectionIdFromRoot(sectionRoot);
    if (!sectionId) return;

    var tokenInput = sectionRoot.querySelector('#PreviewToken-' + sectionId);
    if (tokenInput && !tokenInput.value) tokenInput.value = uid();

    if (sectionRoot.dataset.posterPreviewBound === '1') return;
    sectionRoot.dataset.posterPreviewBound = '1';

    sectionRoot.addEventListener('click', function (e) {
      var btn = e.target.closest('button[type="submit"], input[type="submit"]');
      if (!btn) return;
      if (!sectionRoot.contains(btn)) return;
      if (tokenInput) tokenInput.value = uid();
    }, true);
  }

  function init() {
    var roots = document.querySelectorAll('[id^="MainProduct-"]');
    if (!roots || !roots.length) return;
    for (var i = 0; i < roots.length; i++) bindToSection(roots[i]);
  }

  function patchFetchForCartAdd() {
    if (window.__posterPreviewFetchPatched) return;
    window.__posterPreviewFetchPatched = true;

    var originalFetch = window.fetch;
    if (!originalFetch) return;

    window.fetch = function () {
      var args = arguments;
      var url = args && args[0] ? args[0] : '';
      var urlStr = '';

      try {
        urlStr = (typeof url === 'string') ? url : (url && url.url ? url.url : '');
      } catch (e) {
        urlStr = '';
      }

      var isAdd =
        typeof urlStr === 'string' &&
        (urlStr.indexOf('/cart/add') !== -1 || urlStr.indexOf('/cart/add.js') !== -1);

      return originalFetch.apply(this, args).then(function (res) {
        if (isAdd && res && res.ok) {
          try {
            var activeSection = null;

            var activeEl = document.activeElement;
            if (activeEl) {
              var sec = activeEl.closest && activeEl.closest('section[id^="MainProduct-"]');
              if (sec) activeSection = sec;
            }

            if (!activeSection) {
              var all = document.querySelectorAll('section[id^="MainProduct-"]');
              for (var i = 0; i < all.length; i++) {
                var s = all[i];
                if (s.offsetParent !== null) { activeSection = s; break; }
              }
            }

            if (activeSection) {
              var sectionId = findSectionIdFromRoot(activeSection);
              if (sectionId) capturePreview(activeSection, sectionId);
            }
          } catch (e) {}
        }

        return res;
      });
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
    patchFetchForCartAdd();
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
